import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const displayArticles = articles.slice(0, 9);

  return (
    <section id="articles" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 whitespace-nowrap">
              SEO Guides
            </span>
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight">
              Latest Pandabuy<br />Spreadsheet Articles
            </h2>
          </div>
          <p className="text-foreground-600 text-sm md:text-base max-w-sm leading-relaxed">
            In-depth guides, trend analyses, and expert tips to help you get the most from your pandabuy spreadsheet experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {displayArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer transition-all hover:-translate-y-1 flex flex-col"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <div className="flex items-center gap-2 mb-3">
                  <img
                    src={article.authorAvatar}
                    alt={article.authorName}
                    className="w-5 h-5 rounded-full object-cover"
                  />
                  <span className="text-xs text-foreground-500">{article.authorName} &bull; {article.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-2 leading-snug line-clamp-2 flex-1">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.description}
                </p>
                <span className="text-xs text-accent-600 inline-flex items-center gap-1 whitespace-nowrap group-hover:gap-2 transition-all">
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/shopping-guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-accent-300 text-accent-700 text-sm font-medium hover:bg-accent-50 transition-all whitespace-nowrap cursor-pointer"
          >
            View Shopping Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}